module.exports = __webpack_public_path__ + "img/car-clr-5.e59ae502.png";